export const LOGIN_USER = "/admin/login";
export const FORGET_PASSWORD = "/admin/forgot";
export const UPDATE_ADMIN = "/admin/edit";
export const VERIFY_OTP = "/admin/verify_otp";
export const SET_PASSWORD = "/admin/set_password";
export const VIEW_USER = "/admin/view";
export const RESET_PASSWORD = "/admin/changePassword/";
export const CHANGE_PASSWORD = "/admin/change_password";
// File
export const POST_FILE = "/admin/upload";
export const POST_REMOVE_FILE = "/settings/remove";
//pages
export const CONTENTPAGES = "/admin/pages";
export const ADD_PAGES = "/admin/pages";
export const DELETE_PAGES = "/admin/pages/";
export const EDIT_PAGE = "/admin/pages/";
// users
// export const USER_LIST = "/admin/user/list";
export const USER_LIST = "/admin/waiting/list";
export const UPDATE_USER = "/admin/user/update_status/";
export const ADD_USER = "/admin/user/add";
export const USER_VIEW = "/admin/user/";
export const USER_PRIVATE_CHARACTER = "/admin/user/characters/";
export const USER_SUBSCRIPTION = "/admin/user/subscriptions/";
export const USER_TOKEN = "/admin/user/tokens/";
// profile     views
export const PROFILE_VIEWS = "/admin/profile";
// faq routes
export const FAQ_LIST = "/admin/faq";
export const ADD_FAQ = "/admin/faq";
export const UPDATE_FAQ = "/admin/faq/";
export const VIEWS_FAQ = "/admin/faq/";
export const DELETE_FAQ = "/admin/faq/";
export const GET_CATEGORY_WITHLANG = "/admin/faq/category/";
//faqcategory
export const FAQ_CATEGORY_LIST = "/admin/faq_category";
export const FAQ_CATEGORY_ADD = "/admin/faq_category";
export const FAQ_CATEGORY_EDIT = "/admin/faq_category/";
export const FAQ_CATEGORY_DELETE = "/admin/faq_category/";
export const FAQ_CATEGORY_POSITION = "/admin/faq_category/change_position/";
// settings
export const SETTING_VIEW = "/admin/setting";
export const EDIT_SETTING = "/admin/setting/";
// get appearance
export const GET_APPEARANCE = "/users/character_appearances";
// token packages
export const TOKEN_PACKAGES = "/admin/token/plan";
export const ADD_TOKEN_PACKAGE = "/admin/token/plan";
export const EDIT_TOKEN_PACKAGE = "/admin/token/plan/";
export const DELETE_TOKEN_PACKAGE = "/admin/token/plan/";
export const TOKEN_PACKAGE_DETAIL = "/admin/token/plan/";
// Charcter settings
export const CHARACTER_SETTING = "/admin/character_setting";
export const ADD_CHARACTER = "/admin/character_setting";
export const EDIT_CHARACTER = "/admin/character_setting/";
export const DELETE_CHARACTER = "/admin/character_setting/";
// system access api url
export const GET_SYSTEM = "/admin/staff";
export const ADD_ACCESS = "/admin/staff/add";
export const EDIT_ACCESS = "/admin/staff/";
export const DELETE_ACCESS = "/admin/staff/";

// dashboard data
export const GET_DASHBOARD_DATA = "/admin/dashboard";
export const GET_REVENUE = "/admin/dashboard/revenue";
export const GET_CHARACTER_REVENUE = "/admin/dashboard/characters_graph";
// user revneue
export const USER_REVENUE_LIST = "/admin/user/revenue";
export const USER_TRANSACTION = "/admin/revenue_trasactions";
export const USER_CHARACTER_REVENUE = "/admin/character_revenue";
export const REVENUE_DOWNLOAD = "/admin/user/revenue";
export const PAID_REVENUE_DOWNLOAD = "/admin/revenue_transfer";
// payments wise routes
export const TOKENREVEUNE = "/admin/payments";
export const IMAGESTOKEN = "/admin/characters";
// character list  type wise

export const CHARACTER_LIST = "/admin/characters/list";
export const DELETE_CHARACTER_LIST = "/admin/characters/";
export const VIEW_CHARACTER = "/admin/characters/";
export const CREATE_PERSONAL_CHARACTER = "/users/characters/add";
export const EDIT_CHARACTER_STATUS = "/admin/characters/update-status";
export const BELOVED_REALISTIC_STATUS =
  "/admin/characters/update-beloved-realistic";
// userlist download
export const USER_LIST_DOWNLOAD = "/admin/user";
export const DOWNLOAD_TRANSACTION_LIST = "/admin/payments";
// Langauge
export const LANGUAGE_LIST = "/admin/language";
export const ADD_LANGUAGE = "/admin/language";
export const EDIT_LANGUAGE = "/admin/language/";
export const DELETE_LANGUAGE = "/admin/language/";
export const ALL_LANGUAGE = "/admin/all_languages";
// FEATURE SETTING
export const FEATURE_TOKEN_SETTING = "/admin/feature-token-setting";

// SUBSCRIPTION
export const SUBSCRIPTION_LIST = "/admin/plan";
export const SUBSCRIPTION_ADD = "/admin/plan";
export const SUBSCRIPTION_DETAIL = "/admin/plan";
export const EDIT_SUBSCRIPTION = "/admin/plan/";
export const DELETE_SUBSCRIPTION = "/admin/plan/";
// transaction manage
export const TRANSACTION_LIST = "/admin/payments";
// tags upadte
export const TAGS_LIST = "admin/tags/list";
export const ADD_TAGS = "/admin/tags";
export const EDIT_TAGS = "/admin/tags/";
export const VIEW_TAGS = "/admin/tags/";
export const DELETE_TAGS = "/admin/tags/";

export const HOME_CONTENT = "/admin/contents/list";
export const ADD_HOME = "/admin/contents";
export const EDIT_CONTENT = "/admin/contents/";
export const DELETE_CONTENT = "/admin/contents/";
export const VIEW_HOME = "/admin/contents/";

// character public request
export const GET_CHARACTER_REQUEST_LIST = "/admin/requestPublicCharacter/list";
export const EDIT_CHARACTER_REQUEST = "admin/requestPublicCharacter/action";

// character style
export const GET_CHARACTER_STYLE = "/users/character_style";

// blog category
export const ADD_CATEGORY = "/admin/blog/category";
export const GET_CATEGORY = "/admin/blog/category/list";
export const EDIT_CATEGORY = "/admin/blog/category/";
export const DELETE_CATEGORY = "/admin/blog/category/";

// blogs
export const ADD_BLOG = "/admin/blog";
export const GET_BLOG = "/admin/blogs";
export const EDIT_BLOG = "/admin/blog/";
export const DELETE_BLOG = "/admin/blog/";
export const VIEW_BLOG = "/admin/blog/";

// gift
export const ADD_GIFT = "/admin/gift";
export const GET_GIFT = "/admin/gift/list";
export const EDIT_GIFT = "/admin/gift/";
export const DELETE_GIFT = "/admin/gift/";
export const VIEW_GIFT = "/admin/gift/";

// flag-message
export const GET_FLAG_MESSAGE = "/admin/user/flag-messages";

// contact-form
export const GET_CONTACT_FORM = "/admin/contactus-list";

// promo-code
export const GET_PROMO_CODE = "/admin/promocode/list";
export const ADD_PROMO_CODE = "/admin/promocode/create";
export const EDIT_PROMO_CODE = "/admin/promocode/";

// plans
export const PLAN_LIST = "/admin/plan";

// affiliate
export const GET_INFLUENCER_LIST = "/admin/influencer-requests/list";
export const GET_INFLUENCER_WITHDRAW_LIST = "/admin/withdrawals";
export const GET_INFLUENCER_DETAIL = "/admin/influencer-requests/";
export const UPDATE_USER_STATUS = "/admin/influencers/update/";
export const UPDATE_REQUEST_STATUS = "/admin/influencers/action/";
export const UPDATE_WITHDRAW_REQUEST_STATUS = "/admin/withdrawals";
